module.exports = "/static/Images/Roboto/Roboto-LightItalic.ttf";